import i18next from 'i18next';
import Select from 'react-select';
import AsyncCreatableSelect from 'react-select/async-creatable';
import Creatable from 'react-select/creatable';
import {
  IInputProps,
  ISelectInputProps,
  ISelectOption,
} from 'types/components/inputs/input.interface';
import InputWrapper from '../wrapper/InputWrapper';
import './SelectInput.scss';

const SelectInput = <T,>({
  isCreatable = false,
  isAsync = false,
  isClearable = true,
  onChange,
  value,
  ...props
}: ISelectInputProps<T> & { isClearable?: boolean }) => {
  const CustomSelect = isCreatable
    ? isAsync
      ? AsyncCreatableSelect
      : Creatable
    : Select;

  const handleChange = (newValue: any, actionMeta: any) => {
    if (newValue === null || newValue === undefined) {
      onChange &&
        onChange({ label: '', value: '' } as ISelectOption, actionMeta);
    } else {
      onChange && onChange(newValue as ISelectOption, actionMeta);
    }
  };

  const menuPortalTarget =
    typeof document !== 'undefined' ? document.body : undefined;

  return (
    <InputWrapper
      disabled={!!props.displayMode ? false : !!props.isDisabled}
      {...(props as IInputProps)}
      value={value ? `${value.value}` : undefined}
      render={inputProps => (
        <CustomSelect
          menuPosition='fixed'
          menuPortalTarget={menuPortalTarget}
          {...props}
          {...inputProps}
          closeMenuOnScroll={(e: any) => {
            return (
              (e.target as HTMLElement).classList.contains(
                'react-select__menu-list',
              ) === false
            );
          }}
          value={value}
          placeholder={
            props.placeholder ?? i18next.t('input.placeholder.select-default')
          }
          isDisabled={!!props.displayMode ? true : !!props.isDisabled}
          isClearable={value?.value !== undefined ? isClearable : false}
          onChange={handleChange}
          className='react-select-container'
          classNamePrefix='react-select'
        />
      )}
    />
  );
};

export default SelectInput;
